import { numbers } from './numbers';
import { media } from './media';
import { phone_lists } from './phone-lists';
import { time_conditions } from './time-conditions';
import { groups } from './groups';
import { contacts } from './contacts';
import { worksheets } from './worksheets';
import { sip_accounts } from './sip-accounts';

import { stats } from './stats';
export const pbx = {
  namespaced: true,
  modules: {
    numbers,
    media,
    groups,
    contacts,
    worksheets,
    'phone-lists': phone_lists,
    'sip-accounts': sip_accounts,
    'time-conditions': time_conditions,
    stats
  }
};
